import { Separator } from '@/components/atoms/Separator';
import { Skeleton } from '@/components/atoms/Skeleton';
import ProdutoHome from '@/components/molecules/ProdutoHome';
import { Fragment, useRef } from 'react';
import { useTheme } from 'styled-components';
import * as S from './styles';
import { ListagemProdutosHomeProps } from '../..';
import Text from '@/components/atoms/Text';
import { registrarEvento } from '@/services/googleAnalytics';
import { useSingleItemRowTracker } from '@/hooks/useSingleItemRowTracker';

export default function ListagemProdutosHomeMobile(
  props: ListagemProdutosHomeProps,
) {
  const { $loading, $produtos, style, $funcaoAdicional } = props;

  const theme = useTheme();

  const elementRefs = useRef<Map<string, HTMLDivElement>>(new Map());

  // Set up single item row tracking
  const { registerElement } = useSingleItemRowTracker({
    items: $produtos || [],
    eventName: 'home_visualizou_gift_card',
    visibilityThreshold: 0.6, // 60% visible
    minViewTime: 500, // Must be visible for 500ms
    enabled: !$loading && !!$produtos && $produtos.length > 0,
  });

  const setElementRef = (
    key: string,
    element: HTMLDivElement | null,
    index: number,
  ) => {
    if (element) {
      elementRefs.current.set(key, element);
      registerElement(index, element);
    }
  };

  return (
    <S.Container style={style}>
      {$loading || !$produtos ? (
        <S.Coluna>
          <Skeleton key="skeleton_produto_1" style={{ height: 76 }} />
          <Skeleton
            key="skeleton_produto_2"
            style={{ height: 76, marginTop: theme.spacing[2] }}
          />
          <Skeleton
            key="skeleton_produto_3"
            style={{ height: 76, marginTop: theme.spacing[2] }}
          />
          <Skeleton
            key="skeleton_produto_4"
            style={{
              height: 76,
              marginTop: 8,
              marginBottom: theme.spacing[2],
            }}
          />
        </S.Coluna>
      ) : (
        $produtos?.map((produto, index) => (
          <Fragment key={produto.id}>
            <div
              ref={(el) => setElementRef(produto.id, el, index)}
              onClick={() => {
                $funcaoAdicional?.();
                registrarEvento('home_clicou_gift_card', {
                  produtoID: produto?.produtoID,
                  produto: produto?.nome,
                });
              }}
            >
              <ProdutoHome {...produto} />
            </div>
            {index < $produtos.length - 1 && (
              <Separator $block={false} $orientation="horizontal" />
            )}
          </Fragment>
        ))
      )}
      {!$loading && $produtos?.length === 0 ? (
        <Text
          $size={2}
          $color="neutral"
          $weight="medium"
          $align="left"
          $highContrast={false}
          $text="Não possuimos produtos nesta categoria."
        />
      ) : null}
    </S.Container>
  );
}
